module.exports = "/shifts/components/noShowUserRow-9d4dd9.html";